import React from 'react'
import IgnoredCardListContainer from '../IgnoredCardListContainer'
import { useSelector } from 'react-redux';

function IgnoredList({ title }) {
    const { user } = useSelector((state) => state.user);


    return (
        <IgnoredCardListContainer user={user} matches={user?.ignored} title={title} />
    )
}

export default IgnoredList